import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { getActiveApp } from "@/lib/pwaAppConfig";
import { initSwUpdater } from "@/lib/swUpdater";

// Benign browser notice (Radix popover inside a dialog); CRA's dev overlay treats it as a crash.
window.addEventListener("error", (e) => {
  if (typeof e.message === "string" && e.message.startsWith("ResizeObserver loop")) { e.stopImmediatePropagation(); e.preventDefault(); }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the PER-APP service worker so Chrome/Android fire
// `beforeinstallprompt` with the correct scope + manifest. Each app has
// its own SW (`/sw-<slug>.js`) and cache namespace so installs don't
// share state across apps.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    const app = getActiveApp();
    // No per-app worker for unknown paths: /service-worker.js is now only a
    // kill switch that removes the legacy cache-first shell worker.
    const swUrl = app?.pwa?.sw_path;
    if (!swUrl) return;
    const scope = app?.routing?.scope || "/";
    navigator.serviceWorker
      .register(swUrl, { scope })
      .catch((err) => {
        console.warn(`Service worker registration failed (${swUrl}):`, err);
      });
    initSwUpdater();
  });
}
